<template>
  <div>
    <div class="panel-topnav container-fluid">
      <ul class="nav nav-tabs">
        <li>
          <h3 class="page-title">
            Discounts
          </h3>
        </li>
      </ul>
      <div class="clearfix" />
    </div>

    <el-card v-if="false">
      <el-form inline>
        <el-form-item label="View">
          <el-button-group>
            <el-button
              :type="filters.type === filters.GRID ? 'primary' : null"
              @click="filters.type = filters.GRID"
            >
              <ion-icon name="grid" />
            </el-button>
            <el-button
              :type="filters.type === filters.TABLE ? 'primary' : null"
              @click="filters.type = filters.TABLE"
            >
              <ion-icon name="list" />
            </el-button>
          </el-button-group>
        </el-form-item>
      </el-form>
    </el-card>

    <Marketplace
      v-loading="partnershipsFetchInProgress"
      :partnerships="partnerships"
      :viewmode="filters.type"
      @edit="({ partnership }) => openPartnershipModal({ partnership })"
    />

    <el-dialog
      :visible.sync="isPartnershipModelVisible"
      title="Add partnership"
      append-to-body
      @close="selectedPartnership = null"
      :close-on-click-modal="false"
    >
      <PartnershipForm
        v-model="partnership"
        @save="onSaveFinish"
        @cancel="isPartnershipModelVisible = false"
      />
    </el-dialog>
  </div>
</template>

<script>
import { computed, ref, reactive } from '@vue/composition-api'
import Marketplace from '@/components/marketplace/Marketplace'
import PartnershipForm from '@/components/marketplace/PartnershipForm'
import store from 'store'

export default {
  components: {
    Marketplace,
    PartnershipForm,
  },
  setup(props, { root }) {
    const isPartnershipModelVisible = ref(false)
    const openPartnershipModal = ({ partnership } = {}) => {
      isPartnershipModelVisible.value = true
      selectedPartnership.value = partnership
    }

    store.dispatch('marketplacePartnerships/fetch')

    const partnerships = computed(() => {
      let partnerships = store.state.marketplacePartnerships.entries
      partnerships = filters.filterPartnerships(partnerships)
      return partnerships
    })
    const partnershipsFetchInProgress = computed(
      () => store.state.marketplacePartnerships.fetchInProgress,
    )

    const selectedPartnership = ref(null)
    const partnership = computed(() => {
      return selectedPartnership.value || {}
    })

    const onSaveFinish = () => {
      isPartnershipModelVisible.value = false
      root.$message.success('Partnership saved')
    }

    // filters
    const filters = (() => {
      const GRID = 'GRID'
      const TABLE = 'TABLE'
      const filterPartnerships = (partnerships) => {
        return partnerships.filter((p) => {
          const show = true
          return show
        })
      }

      return reactive({
        GRID,
        TABLE,
        type: GRID,

        filterPartnerships,
      })
    })()

    return {
      isPartnershipModelVisible,
      openPartnershipModal,
      partnerships,
      partnershipsFetchInProgress,

      selectedPartnership,
      partnership,

      onSaveFinish,

      filters,
    }
  },
}
</script>

<style lang="scss">
@import '~assets/css/colors.scss';
@import '~assets/css/vars.scss';
</style>
